import {taskAddLocalRequest, taskDataRequest} from "../store/actions/task.js";
import audioFile from '../assets/audio/notify.wav'
import icon from '../assets/img/BeOn.png'
import {REACT_SOCKET_URL} from '../config.js'
import Api from "../Api.js";
import {dayOffAddLocalRequest, dayOffMessageRequest} from "../store/actions/dayoff.js";
import {dayoffSocketSetter, notificationRequest, taskSocket} from "../store/actions/notification.js";

let socket = null;
let reconnectTimeout = null;
const playNotificationSound = () => {
    const audio = new Audio(audioFile); // ✅ Path to sound file
    audio.play().catch((error) => console.error("🔇 Error playing sound:", error));
};
const showBrowserNotification = (data) => {
    if (document.hidden && Notification.permission === "granted") {
        new Notification("BeOn Day Off Notification", {
            body: data.message,
            icon: icon, // Change to your icon path
        });
    }
};

export const connectDayoffSocket = (token, dispatch,accountantArray) => {
    const WS_URL = `${REACT_SOCKET_URL}/ws/dayoff/?token=${token}`;

    socket = new WebSocket(WS_URL);

    socket.onopen = () => {
        console.log("✅ Dayoff WebSocket connected");
        dispatch(dayoffSocketSetter('on'))

        if (reconnectTimeout) {
            clearTimeout(reconnectTimeout);
            reconnectTimeout = null;
        }
    };

    socket.onmessage = async (event) => {
        console.log(accountantArray)
        const isManager = +localStorage.getItem('user_id') === 86 ||+localStorage.getItem('user_id') === 1024 ||  +localStorage.getItem('user_id') ===1734 || +localStorage.getItem('user_id') === 1918
        const data = JSON.parse(event.data);
        if(data.status === 'update' && data.user === +localStorage.getItem('user_id')) {
            const dayoff = await Api.getDayOff(window.location.search.substring(1))
            dispatch(dayOffAddLocalRequest(dayoff.data))
            playNotificationSound()
            showBrowserNotification(data);
            dispatch(dayOffMessageRequest(data));
            await dispatch(notificationRequest())

        }else if((data.status === 'create' && isManager) || (data.status === 'create' && Array.isArray(accountantArray) && accountantArray.includes(+data.user))){
            const dayoff = await Api.getDayOff(window.location.search.substring(1))
            dispatch(dayOffAddLocalRequest(dayoff.data))
            playNotificationSound()
            showBrowserNotification(data);
            dispatch(dayOffMessageRequest(data));
            await dispatch(notificationRequest())

        }
        console.log("📩 Received Dayoff update:", data);
    };

    socket.onclose = () => {
        console.warn("⚠️ WebSocket disconnected, attempting to reconnect...");
        reconnectDayoffSocket(token, dispatch);
        dispatch(dayoffSocketSetter('reconnect'))

    };

    socket.onerror = (error) => {
        dispatch(dayoffSocketSetter('off'))

        console.error("❌ WebSocket error:", error);
        socket.close();
    };
};

export const reconnectDayoffSocket = (token, dispatch) => {
    if (!reconnectTimeout) {
        reconnectTimeout = setTimeout(() => {
            console.log("♻️Dayoff Reconnecting WebSocket...");
            connectDayoffSocket(token, dispatch);
        }, 3000);
    }
};

export const disconnectDayoffSocket = () => {
    if (socket) {
        socket.close();
    }
};
